import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/Loader"
import React, { useEffect, useMemo, useState } from "react"
import { FaEye, FaSearch } from "react-icons/fa"
import { Button, Card, CardBody, Col, Input, Row, Table } from "reactstrap"
import { fetchData } from "utils/Common_api_functions"
import { useNavigate } from "react-router-dom"
import Configs from "../../config"

const ITEMS_PER_PAGE = 50

const PunchMain = () => {
  const navigate = useNavigate()
  const [employees, setEmployees] = useState([])
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [currentPage, setCurrentPage] = useState(1)

  /* ================= FETCH EMPLOYEES ================= */
  useEffect(() => {
    fetchEmployees()
  }, [])

  const fetchEmployees = async () => {
    const res = await fetchData(setLoading, "users")
    if (res?.success) setEmployees(res.data)
  }

  /* ================= SEARCH ================= */
  const filteredEmployees = useMemo(() => {
    if (!search) return employees
    return employees.filter(emp =>
      `${emp.name} ${emp.email} ${emp.phone} ${emp.employeeId}`
        .toLowerCase()
        .includes(search.toLowerCase())
    )
  }, [search, employees])

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filteredEmployees.length / ITEMS_PER_PAGE)
  const start = (currentPage - 1) * ITEMS_PER_PAGE
  const paginatedEmployees = filteredEmployees.slice(
    start,
    start + ITEMS_PER_PAGE
  )

  /* ================= NAVIGATION ================= */
  const handleView = employeeId => {
    navigate(`${Configs.appurl}punch-details/${employeeId}`)
  }

  /* ================= UI ================= */
  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb title="Payroll" breadcrumbItem="Employees" />
      <Card>
        <CardBody>
          {/* 🔍 SEARCH */}
          <Row className="mb-3">
            <Col md={4}>
              <div className="d-flex align-items-center gap-2">
                <FaSearch />
                <Input
                  placeholder="Search name / email / phone / employee ID"
                  value={search}
                  onChange={e => {
                    setSearch(e.target.value)
                    setCurrentPage(1)
                  }}
                />
              </div>
            </Col>
          </Row>

          {/* ================= TABLE ================= */}
          <Table striped responsive>
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Employee Name</th>
                <th>Employee ID</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Designation</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedEmployees.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center">
                    No Employees Found
                  </td>
                </tr>
              ) : (
                paginatedEmployees.map((emp, index) => (
                  <tr key={emp.id}>
                    <td>{start + index + 1}</td>
                    <td>{emp.name}</td>
                    <td>{emp.employeeId}</td>
                    <td>{emp.email}</td>
                    <td>{emp.phone}</td>
                    <td>{emp.designation}</td>
                    <td>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => handleView(emp.id)}
                      >
                        <FaEye />
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {/* ================= PAGINATION ================= */}
          <nav
            aria-label="Page navigation"
            className="d-flex justify-content-between align-items-center mt-3"
          >
            <h5 className="mb-0">
              Showing {filteredEmployees.length === 0 ? 0 : start + 1} to{" "}
              {Math.min(start + ITEMS_PER_PAGE, filteredEmployees.length)} of{" "}
              {employees.length} entries
            </h5>

            <ul className="pagination mb-0">
              {/* Previous */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {/* Page Numbers */}
              {[...Array(totalPages)].map((_, i) => {
                const pageNum = i + 1
                return (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageNum === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                )
              })}

              {/* Next */}
              <li
                className={`page-item ${
                  currentPage === totalPages || totalPages === 0
                    ? "disabled"
                    : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() =>
                    setCurrentPage(prev => Math.min(prev + 1, totalPages))
                  }
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </CardBody>
      </Card>
    </div>
  )
}

export default PunchMain
